// Disclaimer: This file was upgraded by AI to Angular standards.
import { Injectable } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Injectable({
    providedIn: 'root',
})
export class PagesService {
    constructor (private translateService: TranslateService) {}

    getHeaderTranslation (linkType: string, pageType: string): string {
        const typePrefix = pageType === 'document' ? 'Documents' : 'Pages';

        switch (linkType) {
            case 'slides':
                return this.translateService.getString(`${typePrefix} with this slide`);
            case 'pdf':
                return this.translateService.getString(`${typePrefix} with this PDF`);
            case 'spreadsheet':
                return this.translateService.getString(`${typePrefix} with this spreadsheet`);
            case 'archive':
                return this.translateService.getString(`${typePrefix} with this archive file`);
            case 'text':
                return this.translateService.getString(`${typePrefix} with this text file`);
            default:
                return this.translateService.getString(`${typePrefix} with this ${linkType}`);
        }
    }
}
